// src/contexts/NetworkContext.js 
import React, { createContext, useState, useEffect } from 'react';
import { supportedChains, getChainByChainId } from '../chains';
import { createSecureProvider } from '../utils/secureProvider';

export const NetworkContext = createContext(null);

// Storage key for the selected chain
const SELECTED_CHAIN_KEY = 'bitdog_selected_chain';

export const NetworkProvider = ({ children }) => {
  const [currentChain, setCurrentChain] = useState(supportedChains.bitrock);
  
  // Initialize with a secure provider instead of JsonRpcProvider
  const [provider, setProvider] = useState(
    createSecureProvider(currentChain.rpcUrl)
  );

  // Load the last selected chain from localStorage on startup
  useEffect(() => {
    try {
      const savedChainId = localStorage.getItem(SELECTED_CHAIN_KEY);
      if (savedChainId) {
        const savedChain = getChainByChainId(parseInt(savedChainId));
        if (savedChain) {
          console.log(`Restoring saved chain: ${savedChain.name} (${savedChainId})`);
          // Use secure provider here
          const newProvider = createSecureProvider(savedChain.rpcUrl);
          setCurrentChain(savedChain);
          setProvider(newProvider);
        }
      }
    } catch (error) {
      console.error('Error loading saved chain:', error);
    }
  }, []);

  // Update the chain and provider, and save to localStorage
  const switchNetwork = (chainKey) => {
    const chainConfig = supportedChains[chainKey];
    if (!chainConfig) return console.error(`Unsupported chain: ${chainKey}`);

    // Use secure provider with certificate pinning
    const newProvider = createSecureProvider(chainConfig.rpcUrl);

    // Save the selected chain to localStorage
    try {
      localStorage.setItem(SELECTED_CHAIN_KEY, chainConfig.chainId.toString());
    } catch (error) {
      console.error('Error saving chain selection:', error);
    }

    setCurrentChain(chainConfig);
    setProvider(newProvider);
  };

  return (
    <NetworkContext.Provider value={{ currentChain, provider, switchNetwork }}>
      {children}
    </NetworkContext.Provider>
  );
};